export enum OrderTableStyle {
    Packing,
    Packed,
    Unitary
}
